export default "__VITE_ASSET__cy_PzaFK__"